import React, { useState, useEffect } from 'react';
import {
  ModalOverlay,
  ModalContent,
  CloseButton,
  ModalLeft,
  ModalRight,
  Title,
  Subtitle,
  Paragraph,
  FloatingButtons,
  Button,
} from './ExitIntentModal.styles';

import ExitImage from '../../assets/images/exit-background.png';
import { useTranslation } from 'react-i18next';

const ExitIntentModal = () => {
  const { t } = useTranslation('exitModal');
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (window.innerWidth < 768) return;

    const handleMouseLeave = (e) => {
      const hasShown = sessionStorage.getItem('exitIntentShown');
      if (e.clientY <= 0 && !hasShown) {
        setShow(true);
        sessionStorage.setItem('exitIntentShown', 'true');
      }
    };

    document.addEventListener('mouseleave', handleMouseLeave);
    return () => document.removeEventListener('mouseleave', handleMouseLeave);
  }, []);

  return (
    <ModalOverlay show={show}>
      <ModalContent role="dialog" aria-modal="true">
        <CloseButton aria-label="close" onClick={() => setShow(false)}>
          ×
        </CloseButton>

        <ModalLeft>
          <img src={ExitImage} alt="Exit visual" />
        </ModalLeft>

        <ModalRight>
          <Title>{t('title')}</Title>
          <Subtitle>{t('subtitle')}</Subtitle>
          <Paragraph>
            {t('paragraphBefore')}
            <span>2</span> {t('paragraphAfter')}
          </Paragraph>
        </ModalRight>

        <FloatingButtons>
          <Button primary href="/contato">
            {t('button1')}
          </Button>
          <Button as="button" onClick={() => setShow(false)}>
            {t('button2')}
          </Button>
        </FloatingButtons>
      </ModalContent>
    </ModalOverlay>
  );
};

export default ExitIntentModal;
